import { useState, useEffect, useMemo, useRef } from 'react';
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import NetworkTable, { ColumnConfig, ColumnType, NetworkTableRow } from '../../components/InterfacesTable/NetworkTable/NetworkTable';
import { Box, Container, Grid, Tooltip, Typography } from '@mui/material';
import { geteAllWanInterfacesForAdvSettingsData, getEnableDisableNoNatData, getAllPortConfigsData, getAddEditPortConfigData, getDeletePortConfigData, getAllFirewallRulesData, getInterfacesFirewallRulesData, getAddEditFirewallRuleData, getEnableDisableFirewallRuleData, getDeleteFirewallRuleData, getEnableDisablePortForwardData, updateFirewallPriorityAPI, getIdentityRuleList, getIdentityRuleById, getAllInterfacesData, addEditIdentityRule, deleteIdentityRule, geFirewallProtocolList, getDeviceLinkStatusData } from '../../../../../actions/Users/authenticateOpenEdgeService';
import { GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS, GET_ENABLE_DISABLE_NO_NAT, GET_ALL_PORT_CONFIGS, GET_ADD_EDIT_PORT_CONFIG, GET_DELETE_PORT_CONFIG, GET_ALL_FIREWALL_RULES, GET_INTERFACES_FIREWALL_RULES, GET_ADD_EDIT_FIREWALL_RULE, GET_ENABLE_DISABLE_FIREWALL_RULE, GET_DELETE_FIREWALL_RULE, GET_ENABLE_DISABLE_PORT_FORWARD, GET_IDENTITY_RULES, GET_IDENTITY_RULE_BY_ID, GET_ALL_INTERFACES, CREATE_UPDATE_IDENTITY_RULE, DELETE_IDENTITY_RULE, FETCH_FIREWALL_PROTOCOLS } from '../../../../../actions/types';
import _ from "lodash";
import TabsComponent from '../../../../../components/NewTabs';
import AddEditInterfaceModal from '../../components/Modals/AddEditInterfaceModal';
import LabelValueDisplay from '../../components/LabelValue/LabelValueDisplay';
import ToggleSwitch from '../../components/ToggleSwitch/ToggleSwitch';
import NetworkCardContainer from '../../components/NetworkCards/NetworkCard';
import ToggleControl from '../../components/ToggleControl/ToggleControl';
import CustomLoader from "../../../../../components/Loader/CustomLoader";
import { validateIp, validatePort, validateIpOrSubnet, getDataFromLocalStorage, isVersionLessThanEqual } from "../../../../../utils/util";
import DeleteIcon from '../../../../../asset/image/delete2.svg';
import DeleteWANProfileModal from '../../components/Modals/DeleteProfileModal';
import AddButton from '../../components/AddButton/AddButton';
import IdentityRuleEditor from '../../components/IdentityRules/IdentityRuleEditor';
import { toast } from 'react-toastify';
import InfoIcon from '@mui/icons-material/Info';
import { useConfigAutoRefresh } from "../../hooks/useConfigAutoRefresh";

const SecurityTab = (props) => {
  const { selectedRow, refreshIconClicked, geteAllWanInterfacesForAdvSettingsData, geteAllWanInterfacesForAdvSettings, geteAllWanInterfacesForAdvSettingsLoading, getEnableDisableNoNatData, getEnableDisableNoNat, getEnableDisableNoNatLoading,
    getAllPortConfigsData, getAllPortConfigs, getAllPortConfigsLoading, getAddEditPortConfigData, getAddEditPortConfig, getAddEditPortConfigLoading, getDeletePortConfigData, getDeletePortConfig, getDeletePortConfigLoading,
    getAllFirewallRulesData, getIdentityRuleList, getAllFirewallRules, getIdentityRules, getAllFirewallRulesLoading, getInterfacesFirewallRulesData, getInterfacesFirewallRules, getInterfacesFirewallRulesLoading, getAddEditFirewallRuleData, getAddEditFirewallRule,
    setShowFooter, getAddEditFirewallRuleLoading, getEnableDisableFirewallRuleData, getEnableDisableFirewallRule, getEnableDisableFirewallRuleLoading, getDeleteFirewallRuleData, getDeleteFirewallRule, getDeleteFirewallRuleLoading, getEnableDisablePortForwardData, 
    enableDisablePortConfig, getEnableDisablePortForwardLoading,updateFirewallPriorityAPI, setFirewallRulePriorityLoading, getIdentityRulesLoading, getIdentityRuleById, getIdentityRuleDetails,getAllInterfaces, getAllInterfacesData, firewallRef, addEditIdentityRule, 
    getIdentityRulesByIdLoading, createUpdateIdentityRule, deleteIdentityRule, deletedIdentityRule, geFirewallProtocolList, fetchFwProtocols, notifyConfigAction, notifyConfigActionComplete, getDeviceLinkStatusData, deviceLinkStatusLoading
   } = props;

  const [activeTab, setActiveTab] = useState('filtering_rules');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPortForwardModalOpen, setIsPortForwardModalOpen] = useState(false);
  const [isNatModalOpen, setIsNatModalOpen] = useState(false);
  const [formData, setFormData] = useState<any>({});
  const [target, setTarget] = useState<any>(true);
  const [tableData, setTableData] = useState<any>([]);
  const [row, setRow] = useState<any>({});
  const dispatch = useDispatch();
  const [isIdentityRuleDeleted, setIsIdentityRuleDeleted] = useState(false);
  const [fwProtocols, setFwProtocols] = useState([]);

  const [columns, setColumns] = useState<ColumnConfig[]>([
    {
      label: "",
      key: "enabled",
      type: ColumnType.sliderText,
      maxWidth: "41px",
      // infoIcon: true,
      infoIconMessage: ""
    },
    {
      label: "Order",
      key: "active",
      type: ColumnType.orderColumn,
      maxWidth: "45px",
    },
    {
      label: "Rule Name",
      key: "name",
      type: ColumnType.text,
      maxWidth: "100px",
      formatPlain: true,
    },
    {
      label: "Action",
      key: "target",
      type: ColumnType.boolean,
      booleanList: ['Allow', 'Deny'],
      maxWidth: "63px",
    },
    {
      label: "Protocol",
      key: "proto",
      type: ColumnType.text,
      maxWidth: "65px",
    },
    {
      label: "Rate (Mbps)",
      key: "rate_limit",
      type: ColumnType.text,
      maxWidth: "80px",
    },
    {
      label: "Source",
      key: "src_ip",
      type: ColumnType.text,
      maxWidth: "90px",
      formatPlain: true,
      borderGradient: "linear-gradient(180deg, #354B99 0%, #597DFF 53.37%)"
    },
    {
      label: "Src IP:Port",
      key: "src_port",
      type: ColumnType.text,
      maxWidth: "90px",
      formatPlain: true,
      borderGradient: "linear-gradient(90deg, #597DFF 0%, rgba(53, 75, 153, 0.06) 100%)"
    },
    {
      label: "Destination",
      key: "dest_ip",
      type: ColumnType.text,
      maxWidth: "63px",
      formatPlain: true,
      borderGradient: "linear-gradient(90deg, #434343 0%, #A9A9A9 76.92%)"
    },
    {
      label: "Dest IP:Port",
      key: "dest_port",
      type: ColumnType.text,
      maxWidth: "63px",
      formatPlain: true,
      borderGradient: "linear-gradient(90deg, #A9A9A9 0%, rgba(67, 67, 67, 0) 100%)"
    },
    {
      label: "Src Interface",
      key: "src",
      type: ColumnType.interfaceDetails,
      maxWidth: "90px",
    },
    {
      label: "Dest Interface",
      key: "dest",
      type: ColumnType.interfaceDetails,
      maxWidth: "90px",
    },
   {
      label: "Actions",
      key: "custom",
      type: ColumnType.actions,
      actions: ["setting", "more"],
      moreActions: [
        { key: "copy", label: "Copy" },
        { key: "bidirectional", label: "Bi-Directional" },
        { key: "delete", label: "Delete" },
      ]
    }
  ])
  const [portForwardingColumns, setPortForwardingColumns] = useState<ColumnConfig[]>([
    {
      label: "",
      key: "enabled",
      type: ColumnType.sliderText,
      maxWidth: "41px",
    },
    {
      
      label: "WAN Alias",
      key: "wan_name",
      type: ColumnType.text,
      maxWidth: "145px",
    },
    {
      label: "Protocol",
      key: "proto",
      type: ColumnType.text,
      maxWidth: "63px",
    },
    {
      label: "Source",
      key: "src_ip",
      type: ColumnType.text,
      maxWidth: "118px",
      borderGradient: "linear-gradient(180deg, #354B99 0%, #597DFF 53.37%)"
    },
    {
      label: "WAN:Port",
      key: "src_port",
      type: ColumnType.text,
      maxWidth: "151px",
      borderGradient: "linear-gradient(90deg, #597DFF 0%, rgba(53, 75, 153, 0.06) 100%)"
    },
    {
      label: "Destination",
      key: "dest_ip",
      type: ColumnType.text,
      maxWidth: "63px",
      borderGradient: "linear-gradient(90deg, #434343 0%, #A9A9A9 76.92%)"
    },
    {
      label: "Natted:Port",
      key: "dest_port",
      type: ColumnType.text,
      maxWidth: "63px",
      borderGradient: "linear-gradient(90deg, #A9A9A9 0%, rgba(67, 67, 67, 0) 100%)"
    },
    {
      label: "Actions",
      key: "custom",
      type: ColumnType.actions,
      actions: ["setting", "delete"],
      maxWidth: "72px",
    }
  ])
  const [natColumns, setNatColumns] = useState<ColumnConfig[]>([
    {
      label: "WAN Alias",
      key: "alias",
      type: ColumnType.text,
      maxWidth: "41px",
    },
    {
      label: "Interface",
      key: "interface_type_tmp",
      type: ColumnType.text,
      maxWidth: "145px",
    },
    {
      label: "Outbound",
      key: "no_nat",
      type: ColumnType.sliderText,
      maxWidth: "63px",
    }
  ])
  const [wans, setWans] = useState<any>([]);
  const [isEditPopup, setIsEditPopup] = useState(false);
  const [sourceAddressError, setSourceAddressError] = useState<string>("");
  const [destinationAddressError, setDestinationAddressError] = useState<string>("");
  const [sourcePortError, setSourcePortError] = useState<string>("");
  const [destinationPortError, setDestinationPortError] = useState<string>("");
  const [isPortConfigDeleteModalOpen, setIsPortConfigDeleteModalOpen] = useState(false);
  const [isRuleDeleteModalOpen, setIsRuleDeleteModalOpen] = useState(false);
  const [isIdentityRuleDeleteModalOpen, setIsIdentityRuleDeleteModalOpen] = useState(false);
  const [identityRuleToDelete, setIdentityRuleToDelete] = useState<any>(null);
  const [allInterfaces, setAllInterfaces] = useState<any>([]);
  const [identityRules, setIdentityRules] = useState<any[]>([]);
  // True only while the user is actively adding/editing a rule that has no
  // server id yet. Guards the poll response below from clobbering that
  // in-progress draft (it doesn't exist on the device, so it's never in the
  // fetched list).
  const [isAddingIdentityRule, setIsAddingIdentityRule] = useState(false);
  // True while the open rule has unsaved edits; background polls must not overwrite them.
  const isIdentityRuleDirtyRef = useRef(false);


  const [selectedIdentityRule, setSelectedIdentityRule] = useState<any>({
      name: "New Rule",
      description: "",
      rules: []
    });

  const [identityWANoptions, setIdentityWANOptions] = useState<any[]>([]);
  const [rateLimitConfig, setRateLimitConfig] = useState({
    enabled: false,
    limit: ""
  });

  const filteringRules = useMemo(
    () => tableData.filter(r => !r.rate_limit),
    [tableData]
  );

  const qosRules = useMemo(
    () => tableData.filter(r => Number(r.rate_limit)),
    [tableData]
  );

  const handleChange = (key: string, required=false) => (e: any) => {
    const value = e.target.value;

    if (["src_ip", "dest_ip"].includes(key)) {
      const isRequired = key === "dest_ip";
      const error = validateIp(value, isRequired);

      if (key === "src_ip") {
        setSourceAddressError(error);
      } else {
        setDestinationAddressError(error);
      }
    }

    if (["src_port", "dest_port"].includes(key)) {
      const isRequired = required ? required : false;
      const error = validatePort(value, isRequired);
      if (key === "src_port") {
        setSourcePortError(error);
      } else {
        setDestinationPortError(error);
      }
    }

    if (["source_address", "destination_address"].includes(key)) {
      const isRequired = false;
      const error = validateIpOrSubnet(value, isRequired);

      if (key === "source_address") {
        setSourceAddressError(error);
      } else {
        setDestinationAddressError(error);
      }
    }

    setFormData((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  const fetchTableData = (silent = false) => {
    switch (activeTab) {
      case 'filtering_rules': {
        getAllFirewallRulesData(selectedRow['deviceId'], "filter", silent)
        geFirewallProtocolList(silent);
        break;
      }
      case 'qos_rules': {
        getAllFirewallRulesData(selectedRow['deviceId'], "rate_limit", silent)
        geFirewallProtocolList(silent);
        break;
      }
      case 'identity_rules': {
        getIdentityRuleList(selectedRow['deviceId'], silent);
        getAllInterfacesData(selectedRow['deviceId'],"WAN", undefined, silent);
        break;
      }
      case 'port_forwarding': {
        getAllPortConfigsData(selectedRow?.['deviceId'], silent)
        break;
      }
      case 'nat_outbound': {
        geteAllWanInterfacesForAdvSettingsData(selectedRow?.['deviceId'], silent);
        break;
      }
    }
  }

  // Same fetch as fetchTableData for whichever sub-tab is active, on a 30s
  // idle baseline (immediate on mount/sub-tab switch too), sped up to 2s
  // during an in-flight config change via startAction()/stopAction() below.
  const securityAutoRefresh = useConfigAutoRefresh({
    fetchFns: [fetchTableData],
    enabled: !!selectedRow?.deviceId,
  });

  const handleIdentityRuleChange = (rule) => {
    isIdentityRuleDirtyRef.current = true;
    setSelectedIdentityRule(rule);
  };

  const handleSelectIdentityRule = (rule) => {
    isIdentityRuleDirtyRef.current = false;
    if(rule?.id) {
      setIsAddingIdentityRule(false);
      getIdentityRuleById(selectedRow['deviceId'], rule?.id);
    } else {
      setIsAddingIdentityRule(true);
      setSelectedIdentityRule(rule);
    }
  };

  const handleAddIdentityRule = () => {
    isIdentityRuleDirtyRef.current = false;
    const newRule = {
      name: "New Rule",
      description: "",
      rules: []
    };

    setIdentityRules((prev) => [...prev, newRule]);
    setSelectedIdentityRule(newRule);
    setIsAddingIdentityRule(true);
  };

  const handleDeleteIdentityRule = (rule) => {
    setIdentityRuleToDelete(rule);
    setIsIdentityRuleDeleteModalOpen(true);
  };

  const handleConfirmDeleteIdentityRule = () => {
    let username = getDataFromLocalStorage("loggedInEmail");
    securityAutoRefresh.startAction();
    notifyConfigAction?.();
    deleteIdentityRule(identityRuleToDelete?.id, selectedRow['deviceId'], username, selectedRow.k4Id)
  };


  // Skip the very first firing (tab mount) of the interfaces-status call:
  // InventoryPopup's centralized effect already refreshes it once when this
  // tab opens. Subsequent firings (sub-tab clicks, manual refresh) still call
  // it, since interfaces status is device-wide, not tied to one sub-tab.
  const skipFirstLinkStatusFetchRef = useRef(true);
  useEffect(() => {
    fetchTableData();
    if (skipFirstLinkStatusFetchRef.current) {
      skipFirstLinkStatusFetchRef.current = false;
    } else {
      getDeviceLinkStatusData(selectedRow['k4Id'], selectedRow['deviceId']);
    }
  }, [activeTab, refreshIconClicked])

  useEffect(() => {
      if (firewallRef && activeTab == 'identity_rules') {
         firewallRef.current = {
          saveIdentityRuleSettings: async () => {
            if(selectedIdentityRule?.name.trim() === "") {
              toast.error("Rule name cannot be empty", {
                position: toast.POSITION.BOTTOM_LEFT,
              });
              return;
            }
            const payload = {
              data: {
                action: selectedIdentityRule?.id ? "update" : "create",
                DID: selectedRow.deviceId,
                name: selectedIdentityRule.name,
                description: selectedIdentityRule.description,
                userName: getDataFromLocalStorage("loggedInEmail"),
                k4Id: selectedRow.k4Id,
                rules: selectedIdentityRule.rules.map(rule => ({
                  ul: Number(rule.uploadRate),
                  dl: Number(rule.downloadRate),
                  wan_name: rule.alias_tmp,
                  wan_id: rule.wan_id,
                  wan_link_type: rule.wan_link_type,
                })),
              },
            };

            if(selectedIdentityRule?.id) {
              payload.data['id'] = selectedIdentityRule.id;
            }

            securityAutoRefresh.startAction();
            notifyConfigAction?.();
            addEditIdentityRule(payload);
          },
        };

      }
  }, [activeTab, selectedIdentityRule]);

  useEffect(() => {
    if (!_.isEmpty(geteAllWanInterfacesForAdvSettings) && activeTab == 'nat_outbound') {
      const res = geteAllWanInterfacesForAdvSettings.hasOwnProperty('interfaces') ? geteAllWanInterfacesForAdvSettings?.interfaces : [];
      setTableData(res?.filter(w => w?.device !== "wwan0").map(item => ({ ...item, no_nat: !item.no_nat })));
      dispatch({ type: GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS, payload: {} })
    }

    if (_.isEmpty(getEnableDisableNoNat)) return;
    securityAutoRefresh.stopAction();
    notifyConfigActionComplete?.();
    if (getEnableDisableNoNat.status === true) {
      fetchTableData();
      dispatch({ type: GET_ENABLE_DISABLE_NO_NAT, payload: {} });
    } else {
      setTableData((prev) =>
        prev.map((item) =>
          item.id === row.id ? { ...item, active: row.active } : item
        )
      );
      dispatch({ type: GET_ENABLE_DISABLE_NO_NAT, payload: {} });
    }
  }, [geteAllWanInterfacesForAdvSettings, getEnableDisableNoNat])

  useEffect(() => {
    if (!_.isEmpty(getAllPortConfigs)) {
      const res = getAllPortConfigs.hasOwnProperty('ports') ? getAllPortConfigs?.ports : [];
      setTableData(res);
      dispatch({ type: GET_ALL_PORT_CONFIGS, payload: {} })
    }
    if (!_.isEmpty(getAddEditPortConfig) || !_.isEmpty(getDeletePortConfig) || !_.isEmpty(enableDisablePortConfig)) {
      securityAutoRefresh.stopAction();
      notifyConfigActionComplete?.();
    }
    if (!_.isEmpty(getAddEditPortConfig) && getAddEditPortConfig?.status == true) {
      fetchTableData();
      dispatch({ type: GET_ADD_EDIT_PORT_CONFIG, payload: {} });
      setFormData({});
      handleClosePopup();
      setIsEditPopup(false);
    }
    if (!_.isEmpty(getDeletePortConfig) && getDeletePortConfig?.status == true) {
      fetchTableData();
      dispatch({ type: GET_DELETE_PORT_CONFIG, payload: {} });
      setRow({});
      setIsPortConfigDeleteModalOpen(false);
    }

    if (_.isEmpty(enableDisablePortConfig)) return;
    if (enableDisablePortConfig.status === true) {
      fetchTableData();
      dispatch({ type: GET_ENABLE_DISABLE_PORT_FORWARD, payload: {} });
    } else {
      setTableData((prev) =>
        prev.map((item) =>
          item.id === row.id ? { ...item, active: row.active } : item
        )
      );
      dispatch({ type: GET_ENABLE_DISABLE_PORT_FORWARD, payload: {} });
    }
  }, [getAllPortConfigs, getAddEditPortConfig, getDeletePortConfig, enableDisablePortConfig])

  useEffect(() => {
    if (!_.isEmpty(getIdentityRules) && activeTab == 'identity_rules') {
      const identityRuleList = getIdentityRules.hasOwnProperty('identity_rule_list') ? getIdentityRules?.identity_rule_list : [];

      if (isAddingIdentityRule) {
        // The rule being added/edited has no id yet, so it can't be in
        // identityRuleList — keep it in place instead of letting the poll
        // response replace the list and reselect the first saved rule.
        setIdentityRules([...identityRuleList, selectedIdentityRule]);
      } else {
        setIdentityRules(identityRuleList);
        if (identityRuleList.length > 0 && !isIdentityRuleDirtyRef.current) {
          let id = isIdentityRuleDeleted ? identityRuleList[0]?.id : selectedIdentityRule?.id ? selectedIdentityRule?.id : identityRuleList[0]?.id;
          // Poll-triggered fetches stay silent; only the post-delete reload shows the loader.
          getIdentityRuleById(selectedRow['deviceId'], id, !isIdentityRuleDeleted);
        }
      }

      dispatch({ type: GET_IDENTITY_RULES, payload: {} })
    }

    if (!_.isEmpty(createUpdateIdentityRule) || !_.isEmpty(deletedIdentityRule)) {
      securityAutoRefresh.stopAction();
      notifyConfigActionComplete?.();
    }
    if (!_.isEmpty(createUpdateIdentityRule) && createUpdateIdentityRule?.status == true) {
      isIdentityRuleDirtyRef.current = false;
      setIsAddingIdentityRule(false);
      fetchTableData();
      dispatch({ type: CREATE_UPDATE_IDENTITY_RULE, payload: {} });
    }
    if (!_.isEmpty(deletedIdentityRule) && deletedIdentityRule?.status == true) {
      isIdentityRuleDirtyRef.current = false;
      fetchTableData();
      setIsIdentityRuleDeleteModalOpen(false);
      setIdentityRuleToDelete(null);
      setIsIdentityRuleDeleted(true)
      dispatch({ type: DELETE_IDENTITY_RULE, payload: {} });
    }

  }, [getIdentityRules, createUpdateIdentityRule, deletedIdentityRule])

  useEffect(() => {
    if (!_.isEmpty(getIdentityRuleDetails)) {
      if (isIdentityRuleDirtyRef.current) {
        // Unsaved local edits — drop the polled copy instead of overwriting them.
        dispatch({ type: GET_IDENTITY_RULE_BY_ID, payload: {} });
        return;
      }
      setIsIdentityRuleDeleted(false);
      const ruleDetails = getIdentityRuleDetails?.rule_details;

      const apiRules = ruleDetails?.rules?.map((rule, index) => ({
        id: `tp_${rule.wan_id}_${index}_${rule.wan_name}`,  // More unique ID with WAN name
        alias_tmp: rule.wan_name,
        uploadRate: rule.ul,
        downloadRate: rule.dl,
        wan_id: rule.wan_id,
        wan_link_type: rule.wan_link_type,
      })) || [];

      let finalRules = apiRules;
      if (selectedIdentityRule?.id === ruleDetails?.id && selectedIdentityRule?.rules?.length > 0) {
        const localPolicies = selectedIdentityRule.rules.filter(localRule => 
          localRule.id.includes('_') && 
          /^tp_\d+_[\d.]+/.test(localRule.id) &&
          !apiRules.some(apiRule => 
            apiRule.alias_tmp === localRule.alias_tmp && 
            Math.abs(parseFloat(apiRule.uploadRate || 0) - parseFloat(localRule.uploadRate || 0)) < 0.01 &&
            Math.abs(parseFloat(apiRule.downloadRate || 0) - parseFloat(localRule.downloadRate || 0)) < 0.01
          )
        );

        if (localPolicies.length > 0) {
          finalRules = [...apiRules, ...localPolicies];
        }
      }

      const updatedRuleDetails = {
        ...ruleDetails,
        rules: finalRules,
      };

      setSelectedIdentityRule(updatedRuleDetails);
      dispatch({ type: GET_IDENTITY_RULE_BY_ID, payload: {} });
    }

    
  }, [getIdentityRuleDetails])

  useEffect(() => {
      if (!_.isEmpty(getAllInterfaces)) {
        const data = getAllInterfaces && getAllInterfaces.hasOwnProperty('status') && getAllInterfaces.status == true ? getAllInterfaces?.interfaces : [];
        setIdentityWANOptions(data.map((intf) => ({
          ...intf,
          key: intf.id,
          label: intf.alias
        })));
        dispatch({ type: GET_ALL_INTERFACES, payload: {} })
      }
    }, [getAllInterfaces])


  useEffect(() => {
    if (!_.isEmpty(fetchFwProtocols)) {
      const protocols = fetchFwProtocols?.data?.protocols || [];
      setFwProtocols(protocols);
      dispatch({ type: FETCH_FIREWALL_PROTOCOLS, payload: {} })
    }
  }, [fetchFwProtocols])

  useEffect(() => {
    if (!_.isEmpty(getAllFirewallRules)) {
      const res = getAllFirewallRules.hasOwnProperty('interfaces') ? getAllFirewallRules?.interfaces : [];
      const updatedTableData = res.map((row: any) => ({
        ...row,
        target: row.target === "ACCEPT",
        proto: row.proto
      }));
      setTableData(updatedTableData);
      dispatch({ type: GET_ALL_FIREWALL_RULES, payload: {} })
    }
    if (!_.isEmpty(getAddEditFirewallRule) || !_.isEmpty(getEnableDisableFirewallRule) || !_.isEmpty(getDeleteFirewallRule)) {
      securityAutoRefresh.stopAction();
      notifyConfigActionComplete?.();
    }
    if (!_.isEmpty(getAddEditFirewallRule) && getAddEditFirewallRule?.status == true) {
      fetchTableData();
      dispatch({ type: GET_ADD_EDIT_FIREWALL_RULE, payload: {} });
      setFormData({});
      handleClosePopup();
      setIsEditPopup(false);
    }
    if (!_.isEmpty(getDeleteFirewallRule) && getDeleteFirewallRule?.status == true) {
      fetchTableData();
      dispatch({ type: GET_DELETE_FIREWALL_RULE, payload: {} });
      setRow({});
      setIsRuleDeleteModalOpen(false);
    }

    if (_.isEmpty(getEnableDisableFirewallRule)) return;
    if (getEnableDisableFirewallRule.status === true) {
      fetchTableData();
      dispatch({ type: GET_ENABLE_DISABLE_FIREWALL_RULE, payload: {} });
    } else {
      setTableData((prev) =>
        prev.map((item) =>
          item.id === row.id ? { ...item, active: row.active } : item
        )
      );
      dispatch({ type: GET_ENABLE_DISABLE_FIREWALL_RULE, payload: {} });
    }
  }, [getAllFirewallRules, getAddEditFirewallRule, getEnableDisableFirewallRule, getDeleteFirewallRule])

  const tabs = [
    { tabName: 'Firewall Rules', tabValue: 'filtering_rules', pathName: '/inventory' },
    { tabName: 'QoS Rules', tabValue: 'qos_rules', pathName: '/inventory' },
    { tabName: 'Identity Rules', tabValue: 'identity_rules', pathName: '/inventory' },
    { tabName: 'Port Forwarding', tabValue: 'port_forwarding', pathName: '/inventory' },
    { tabName: 'NAT - Outbound', tabValue: 'nat_outbound', pathName: '/inventory' },
  ];

  const showInfoIcon = ["filtering_rules", "qos_rules", "identity_rules"].includes(activeTab);


  const getTabsByLicense = (licenseTier) => {
    return tabs
    .map((tab) => {
      if (
        isVersionLessThanEqual(selectedRow['current_EOS_version'], 'v1.1.0.754') &&
        tab.tabValue === "filtering_rules"
      ) {
        return { ...tab, tabName: "Firewall Rules" };
      }
      return tab;
    })
    .filter(({ tabValue }) => {
      if(isVersionLessThanEqual(selectedRow['current_EOS_version'], 'v1.1.0.754') && (tabValue === "qos_rules" || tabValue === "identity_rules")) {
        return false;
      }
      if (licenseTier === 'T101' && tabValue === 'qos_rules') {
        return false;
      }
      if (tabValue === 'identity_rules' && !licenseTier?.startsWith('T104')) {
        return false;
      }

      return true;
    });
  };

  const doNavigateTab = (pathname, tabName) => {
    setActiveTab(tabName);
    setTableData([]);
    setIsAddingIdentityRule(false);
    isIdentityRuleDirtyRef.current = false;
  }

  useEffect(() => {
      if (activeTab === "identity_rules") {
          setShowFooter(true);   // show footer
      } else {
          setShowFooter(false);  // hide footer
      }
  }, [activeTab]);

  const handleActionClick = (
    type: "setting" | "refresh" | "delete" | "portal" | "edit" | "copy" | "bidirectional",
    headerKey: string,
    row: NetworkTableRow
  ) => {
    console.log(`Action "${type}" clicked on ${headerKey}`, row);
    setRow(row);
    switch (type) {
      case "delete":
        if(activeTab == 'port_forwarding') {
          setIsPortConfigDeleteModalOpen(true);
        }
        if(activeTab == 'filtering_rules' || activeTab == "qos_rules") {
          setIsRuleDeleteModalOpen(true);
        }
        break;
      case "setting": {
        setIsEditPopup(true);
        if (activeTab === "filtering_rules" || activeTab == "qos_rules") {
          setIsModalOpen(true);
          setTarget(row?.['target']);
          setRateLimitConfig({
            enabled: !!row?.['rate_limit'],
            limit: row?.['rate_limit'] || ""
          });
          setFormData({
            id: row['id'],
            name: row['name'],
            protocol: row['proto'],
            source_address: row['src_ip'],
            src_port: row['src_port'],
            destination_address: row['dest_ip'],
            dest_port: row['dest_port'],
            src_interface: row['src']?.[0]?.['alias'],
            dest_interface: row['dest']?.[0]?.['alias']
          });
        }
        else if (activeTab === "port_forwarding") {
          setIsPortForwardModalOpen(true);
          setFormData({
            wan_name: row['wan_name'],
            protocol: row['proto'] == 'tcp' ? 'TCP' : 'UDP',
            src_ip: row['src_ip'],
            src_port: row['src_port'],
            dest_ip: row['dest_ip'],
            dest_port: row['dest_port'],
            id: row['id']
          });
        }
        break;
      }
      case "copy": {
        if (activeTab === "filtering_rules" || activeTab === "qos_rules") {
          setIsEditPopup(false); 
          setIsModalOpen(true);

          setTarget(row?.target);

          setRateLimitConfig({
            enabled: !!row?.rate_limit,
            limit: row?.rate_limit || ""
          });

          setFormData({
            name: `${row?.name}_copy`,
            protocol: row?.proto,
            source_address: row?.src_ip,
            src_port: row?.src_port,
            destination_address: row?.dest_ip,
            dest_port: row?.dest_port,
            src_interface: row?.src?.[0]?.['alias'],
            dest_interface: row?.dest?.[0]?.['alias']
          });
        }
        break;
      }

      case "bidirectional": {
        if (activeTab === "filtering_rules" || activeTab === "qos_rules") {
          setIsEditPopup(false);
          setIsModalOpen(true);

          setTarget(row?.target);

          setRateLimitConfig({
            enabled: !!row?.rate_limit,
            limit: row?.rate_limit || ""
          });

          setFormData({
            name: `${row?.name}_bi`,
            protocol: row?.proto,

            // swap source & destination
            source_address: row?.dest_ip,
            src_port: row?.dest_port,
            src_interface: row?.dest?.[0]?.['alias'],

            destination_address: row?.src_ip,
            dest_port: row?.src_port,
            dest_interface: row?.src?.[0]?.['alias']
          });
        }
        break;
      }
      default:
        console.warn(`Unhandled action type: ${type}`);
    }
  };

  const handleClosePopup = () => {
    setIsEditPopup(false);
    setFormData({});
    setRow({});
    setSourceAddressError('');
    setDestinationAddressError('');
    setSourcePortError('');
    setDestinationPortError('');
    setRateLimitConfig({ enabled: false, limit: "" });

    switch (activeTab) {
      case 'filtering_rules': {
        setIsModalOpen(false);
        dispatch({ type: GET_ADD_EDIT_FIREWALL_RULE, payload: {} });
        break;
      }
      case 'qos_rules': {
        setIsModalOpen(false);
        dispatch({ type: GET_ADD_EDIT_FIREWALL_RULE, payload: {} });
        break;
      }
      case 'port_forwarding': {
        setIsPortForwardModalOpen(false);
        dispatch({ type: GET_ADD_EDIT_PORT_CONFIG, payload: {} });
        break;
      }
      case 'nat_outbound': {
        setIsNatModalOpen(false);
        break;
      }
    }
  }
  const handleAddRule = () => {
    const selectedSrcInterface = allInterfaces?.find((intrface) => intrface.alias == formData.src_interface);
    const selectedDestInterface = allInterfaces?.find((intrface) => intrface.alias == formData.dest_interface);

    const payload = {
      data: {
        DID: selectedRow['deviceId'],
        name: formData?.name,
        src_ip: formData?.source_address,
        src_port: formData?.src_port,
        dest_ip: formData?.destination_address,
        dest_port: formData?.dest_port,
        proto: formData?.protocol,
        target: activeTab === 'qos_rules' ? 'ACCEPT' : (target ? 'ACCEPT' : 'REJECT'),
        src: selectedSrcInterface ? [selectedSrcInterface] : undefined,
        dest: selectedDestInterface ? [selectedDestInterface] : undefined,
        rule_type: activeTab === 'qos_rules'? "rate_limit" : "filter",

        ...(activeTab === 'qos_rules'
          && { rate_limit: rateLimitConfig.limit }),

        ...(isEditPopup && { id: formData?.id }),
      }
    };

    securityAutoRefresh.startAction();
    notifyConfigAction?.();
    isEditPopup ? getAddEditFirewallRuleData(payload, 'updateFirewall') : getAddEditFirewallRuleData(payload, 'addFirewall');
  }
  const handleAddPortForward = () => {
    const selectedProfile = wans?.find(w => w?.alias === formData?.wan_name);
    const payload = {
      data: {
        "DID": selectedRow?.['deviceId'],
        "action": isEditPopup ? undefined : "create",
        "wan_name": selectedProfile?.['alias'],
        "wan_id": selectedProfile?.['id'],
        "wan_type": selectedProfile?.['interface_link_type'],
        "proto": formData['protocol'] == 'TCP' ? 'tcp' : 'udp',
        "src_port": formData['src_port'],
        "src_ip": formData['src_ip'],
        "dest_ip": formData['dest_ip'],
        "dest_port": formData['dest_port'],
        ...(isEditPopup && { id: formData?.id })
      }
    }
    securityAutoRefresh.startAction();
    notifyConfigAction?.();
    isEditPopup ? getAddEditPortConfigData(payload, 'updatePortForwarding') : getAddEditPortConfigData(payload, 'addPortForwarding')
  }
  const handleAddNatOutbound = () => {
    setIsModalOpen(false);
  }

  const handleToggle = (headerKey: string, value: boolean, row: NetworkTableRow) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, [headerKey]: value } : item
      )
    );
    const payload = {
      "DID": selectedRow['deviceId'],
      "id": row['id'],
      "interface_type_tmp": row['interface_type_tmp'],
      "no_nat": !value
    }
    setRow(row);
    securityAutoRefresh.startAction();
    notifyConfigAction?.();
    getEnableDisableNoNatData(payload);
  };

  const handleToggleRule = (headerKey: string, value: boolean, row: NetworkTableRow) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, [headerKey]: value } : item
      )
    );
    const payload = {
      "DID": selectedRow['deviceId'],
      "id": row['id'],
      "enabled": value,
      "rule_type": activeTab === "qos_rules"? "rate_limit": "filter"
    }
    setRow(row);
    securityAutoRefresh.startAction();
    notifyConfigAction?.();
    getEnableDisableFirewallRuleData(payload);
  };

  const handleTogglePortForward = (headerKey: string, value: boolean, row: NetworkTableRow) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, [headerKey]: value } : item
      )
    );
    const payload = {
      "DID": selectedRow['deviceId'],
      "id": row['id'],
      "enabled": value
    }
    setRow(row);
    securityAutoRefresh.startAction();
    notifyConfigAction?.();
    getEnableDisablePortForwardData(payload);
  };

  const handleDragDropRow = (row, newIndex) => {
    if (activeTab !== 'filtering_rules') return;

    securityAutoRefresh.startAction();
    notifyConfigAction?.();
    updateFirewallPriorityAPI(
      selectedRow.deviceId,
      row,
      newIndex,
      "filter"
    ).then((res) => {
      if (res?.status) {
        fetchTableData();
      }
    }).finally(() => {
      securityAutoRefresh.stopAction();
      notifyConfigActionComplete?.();
    });
  };

  useEffect(() => {
    if(isPortForwardModalOpen) {
      geteAllWanInterfacesForAdvSettingsData(selectedRow?.['deviceId']);
    }
    if(isModalOpen) {
      getInterfacesFirewallRulesData(selectedRow?.['deviceId']);
    }
  }, [isPortForwardModalOpen, isModalOpen])

  useEffect(() => {
    if (!_.isEmpty(geteAllWanInterfacesForAdvSettings) && isPortForwardModalOpen) {
      const res = geteAllWanInterfacesForAdvSettings.hasOwnProperty('interfaces') ? geteAllWanInterfacesForAdvSettings?.interfaces : [];
      const filteredRes = res.map(({ alias, id, interface_link_type, device }) => ({ alias, id, interface_link_type, device }));
      setWans(filteredRes);
      dispatch({ type: GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS, payload: {} })
    }
    if (!_.isEmpty(getInterfacesFirewallRules)) {

      const wanInterfaces = getInterfacesFirewallRules?.interfaces || [];
      const accessNetworks = getInterfacesFirewallRules?.networks || [];

      const wanList = wanInterfaces.map(({ alias, id, src_type }) => ({
        alias,
        wan_lan_id: id,
        src_type
      }));

      const networkList = accessNetworks.map(({ alias, id, src_type }) => ({
        alias,
        wan_lan_id: id,
        src_type
      }));

      const combinedList = [
        ...wanList,
        {alias:"DIVIDER"},
        ...networkList
      ];

      setAllInterfaces(combinedList);

      dispatch({ type: GET_INTERFACES_FIREWALL_RULES, payload: {} });
    }
  }, [geteAllWanInterfacesForAdvSettings, getInterfacesFirewallRules])

  const isFormValid = (): boolean => {
    if (!formData) return false;
    const { wan_name, protocol, dest_ip, dest_port, name, src_interface, dest_interface, source_address, destination_address } = formData;
    const { limit } = rateLimitConfig
    if(activeTab == 'port_forwarding') {
      if (!wan_name || !protocol || !dest_ip || !dest_port) {
        return false;
      }
  
      if ( sourceAddressError || destinationAddressError || sourcePortError || destinationPortError ) {
        return false;
      }
    }

    if(activeTab == 'filtering_rules' || activeTab == "qos_rules") {
      if (!name || !protocol) {
        return false;
      }
      if ( sourceAddressError || destinationAddressError || sourcePortError || destinationPortError ) {
        return false;
      }
      if(activeTab == "qos_rules" && (limit === "" || limit === null || Number(limit) <= 0)){
        return false;
      }
    }

    return true;
  };

  const handleRateLimitToggle = (value: boolean) => {
    setRateLimitConfig((prev) => ({ ...prev, enabled: value }));
  };

  const handleRateValueChange = (e: any) => {
    const value = e.target.value;
    setRateLimitConfig((prev) => ({ ...prev, limit: value }));
  };

  const fetchTooltipMessage = () => {
    if (activeTab === "filtering_rules") {
      return (
        <div>Control network traffic by defining allow or deny policies based on IPs, ports, and protocols.</div>
        );
    }
    if (activeTab === "qos_rules") {
      return <div>Allocate WAN bandwidth based on IPs, ports, protocols</div>;
    }
    if (activeTab === "identity_rules") {
      return <div>Apply security policy for authenticated user or assigned device.</div>;
    }
  };

  return (<div className="internalPadding">
    <div className="tabsHeaderContainer" >
      <TabsComponent tabs={getTabsByLicense(selectedRow?.licenseTier)} handleChangeTab={doNavigateTab} activeTab={activeTab} isSubTabs={true} removemarginTop={true} />
      {
        showInfoIcon && (
          <div className="tabsHeaderInfo" >
            <Tooltip placement="left" title={fetchTooltipMessage()} arrow>
              <InfoIcon className="tabsHeaderInfoIcon"/>
            </Tooltip>
          </div>
        )
      }
      
    </div>
    <div className="tab-content lan-tab-contnent" style={{height: '377px'}}>
     {(activeTab === 'filtering_rules' || activeTab === 'qos_rules') && (
        <Container maxWidth="xl" className="app-container">
          <Box my={0}>
            <NetworkTable
              data={activeTab === 'filtering_rules' ? filteringRules : qosRules}
              columns={activeTab === 'filtering_rules' ? columns.filter(col => col.key !== "rate_limit") :columns.filter(col => col.key !== "active" && col.key !== "target") }
              showFilterBar
              addButtonLabel={activeTab === 'filtering_rules' ? "Add Firewall Rule" : "Add QoS Rule"}
              onAddClick={() => setIsModalOpen(true)}
              onActionClick={handleActionClick}
              onToggle={handleToggleRule}
              onDragDropRow={activeTab === 'filtering_rules' ? handleDragDropRow : undefined }
            />
          </Box>
        </Container>
      )}


      {activeTab == 'port_forwarding' && <Container maxWidth="xl" className="app-container">
        <Box my={0}>
          <NetworkTable
            data={tableData}
            columns={portForwardingColumns}
            showFilterBar
            addButtonLabel="Add Port Forward"
            onAddClick={() => { setIsPortForwardModalOpen(true) }}
            onActionClick={handleActionClick}
            onToggle={handleTogglePortForward}
          />
        </Box>
      </Container>}
      {activeTab == 'nat_outbound' && <Container>
        <Box my={0}>
          <NetworkTable
            data={tableData}
            columns={natColumns}
            showFilterBar
            // addButtonLabel="Add NAT Outbound"
            // onAddClick={() => { setIsNatModalOpen(true) }}
            onToggle={handleToggle}
          />
        </Box>
      </Container>}
      {
        activeTab == 'identity_rules' && (
          <div
            className="wan-tab-grid-container"
            style={{ display: "flex",flexDirection:'row', flexFlow: "wrap" }}
          >
            <Box
              className="wan-tab-grid-container wantab-left-panel"
              sx={{
                minWidth: "200px",   
                height:"333px",         
                borderRight: "1px solid #e0e0e0",
                border: "1px solid #d1d5db",
                padding: "12px",
                display: "flex",
                flexDirection: "column",
                gap: 1,
                backgroundColor: "#f9f9f9",
                // height: "89%",
                paddingTop: "0px"
              }}
            >
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#f9f9f9",
                  zIndex: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingBottom: "8px",
                  borderBottom: "1px solid #d1d5db",
                  padding: "10px"
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Identity Rules
                </Typography>
                <div><AddButton onAddClick={handleAddIdentityRule} addLabel="+" maxWidth="32px" /></div>
              </Box>

              {identityRules.map((rule) => (
                <Box
                  key={rule.id}
                  onClick={() => handleSelectIdentityRule(rule)}
                  sx={{
                    padding: "7px 14px",
                    borderRadius: "4px",
                    border: "1.6px solid",
                    borderColor:
                      selectedIdentityRule?.id === rule.id ? "#5F5FFF" : "#E5E7EB",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#F3F4F6",
                      borderColor:
                        selectedIdentityRule?.id === rule.id ? "#5F5FFF" : "#D1D5DB", // slightly darker on hover
                    },
                    transition: "all 0.2s ease"

                  }}
                >
                  <Tooltip title={rule.name} placement="top" arrow>
                   <Typography
                      variant="body2"
                      className="text-truncate"
                      // fontWeight={selectedProfile?.id === profile.id ? 600 : 400}
                      sx={{ color: "#111827", width:"165px" }}
                    >
                      {rule.name}
                    </Typography>
                    </Tooltip>
                </Box>
              ))}
            </Box>
            
            <IdentityRuleEditor
              identityRuleList = {identityRules}
              identityRule={selectedIdentityRule}
              identityWANoptions={identityWANoptions}
              onChange={handleIdentityRuleChange}
              onDeleteClick={() => handleDeleteIdentityRule(selectedIdentityRule)}
            />
        

          </div>
        )
      }


      {geteAllWanInterfacesForAdvSettingsLoading || getEnableDisableNoNatLoading || getAllPortConfigsLoading || getAddEditPortConfigLoading || getDeletePortConfigLoading || getAllFirewallRulesLoading || getInterfacesFirewallRulesLoading || getAddEditFirewallRuleLoading || getEnableDisableFirewallRuleLoading || getDeleteFirewallRuleLoading || getEnableDisablePortForwardLoading || setFirewallRulePriorityLoading || getIdentityRulesLoading || getIdentityRulesByIdLoading || deviceLinkStatusLoading ? (
        <CustomLoader
          showLoader={true}
          loadingText={"Please wait..."}
        />
      ) : null}
    </div>

    <AddEditInterfaceModal
      open={isModalOpen}
      onClose={handleClosePopup}
      onSave={handleAddRule}
      saveText={isEditPopup ? 'Update' : 'Add'}
      disableSave={!isFormValid()}
      title={isEditPopup ? activeTab == 'filtering_rules'? 'Update Firewall Rule': "Update QoS Rule" : activeTab == 'filtering_rules'?'Add Firewall Rule': "Add QoS Rule"}
      layout={[
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Rule Name"
                  isInput
                  value={formData?.name}
                  onChange={handleChange("name")}
                  placeholder="Enter Rule Name"
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: activeTab == 'qos_rules'? null:  (
                <ToggleSwitch
                  label="Action"
                  description={
                    activeTab === 'qos_rules'
                      ? "Traffic is always allowed for QoS rules."
                      : "Choose whether to allow or deny traffic"
                  }
                  checked={activeTab == 'qos_rules'? true: target}
                  onChange={setTarget}
                  trueLabel="Allow"
                  falseLabel="Deny"
                  disabled={activeTab == 'qos_rules'}
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Protocol"
                  isDropdown
                  dropdownOptions={activeTab == 'qos_rules'? fwProtocols.filter(el=> el !== "management"): fwProtocols}
                  value={formData?.protocol}
                  onChange={handleChange("protocol")}
                  placeholder="Select Protocol"
                />
              ),
              gridSize: activeTab == 'qos_rules'? 6: 12,
            },
             {
              component: activeTab == 'qos_rules' &&(
                
                  <LabelValueDisplay
                    label="Rate (Mbps)"
                    isInput
                    value={rateLimitConfig.limit}
                    onChange={handleRateValueChange}
                    placeholder="Enter rate"
                    // disabled={!rateLimitConfig.enabled}
                  />
               
              ),
              gridSize: 6,
            }
          ],
        },
        {
          columns: [
            {
              component: false && (
                <ToggleSwitch
                  label="Enable Rate Limit"
                  // description="Limit bandwidth for this rule"
                  checked={rateLimitConfig.enabled}
                  onChange={handleRateLimitToggle}
                  disabled={!target}
                  trueLabel=""
                  falseLabel=""
                  width={"30px"}
                />
              ),
              gridSize: 6,
            },
            {
              component: false &&(
                
                  <LabelValueDisplay
                    label="Rate (Mbps)"
                    isInput
                    value={rateLimitConfig.limit}
                    onChange={handleRateValueChange}
                    placeholder="Enter rate"
                    disabled={!rateLimitConfig.enabled}
                  />
               
              ),
              gridSize: 6,
            }
          ],
        },

        {
          columns: [
            {
              component: (
                <NetworkCardContainer title="Source" borderGradient="linear-gradient(90deg, #597DFF 0%, rgba(53, 75, 153, 0) 100%)">
                  <LabelValueDisplay
                    label="Interface"
                    isDropdown
                    dropdownOptions={allInterfaces?.map(intface => intface?.alias)}
                    tooltipMapping={
                      allInterfaces
                        ?.filter(item => item?.alias !== "DIVIDER")
                        .reduce((acc, { alias, src_type }) => {
                          acc[alias] =
                            src_type === "lan"
                              ? "Access Network"
                              : "WAN Interface";
                          return acc;
                        }, {})
                    }
                    value={formData?.src_interface}
                    onChange={handleChange("src_interface")}
                    placeholder="Select Interface"
                    disabled={formData?.protocol == 'management'}
                  />

                  <LabelValueDisplay
                    label="IP/Subnet"
                    isInput
                    value={formData?.source_address}
                    onChange={handleChange("source_address")}
                    placeholder="Enter IP/Subnet"
                    error={sourceAddressError}
                    disabled={formData?.protocol == 'management'}
                  />

                  <LabelValueDisplay
                    label="Port"
                    isInput
                    value={formData?.src_port}
                    onChange={handleChange("src_port")}
                    placeholder="Enter Port"
                    error={sourcePortError}
                    disabled={formData?.protocol == 'management'}
                  />
                </NetworkCardContainer>
              ),
              gridSize: 6,
            },
            {
              component: (
                <NetworkCardContainer title="Destination" borderGradient="linear-gradient(90deg, #6E7079 0%, rgba(53, 75, 153, 0) 100%)">
                  <LabelValueDisplay
                    label="Interface"
                    isDropdown
                    dropdownOptions={allInterfaces?.map(intface => intface?.alias)}
                    tooltipMapping={
                      allInterfaces
                        ?.filter(item => item?.alias !== "DIVIDER")
                        .reduce((acc, { alias, src_type }) => {
                          acc[alias] =
                            src_type === "lan"
                              ? "Access Network"
                              : "WAN Interface";
                          return acc;
                        }, {})
                    }
                    value={formData?.dest_interface}
                    onChange={handleChange("dest_interface")}
                    placeholder="Select Interface"
                    disabled={formData?.protocol == 'management'}
                  />

                  <LabelValueDisplay
                    label="IP/Subnet"
                    isInput
                    value={formData?.destination_address}
                    onChange={handleChange("destination_address")}
                    placeholder="Enter IP/Subnet"
                    error={destinationAddressError}
                    disabled={formData?.protocol == 'management'}
                  />

                  <LabelValueDisplay
                    label="Port"
                    isInput
                    value={formData?.dest_port}
                    onChange={handleChange("dest_port")}
                    placeholder="Enter Port"
                    error={destinationPortError}
                    disabled={formData?.protocol == 'management'}
                  />
                </NetworkCardContainer>
              ),
              gridSize: 6,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(getAddEditFirewallRule) && getAddEditFirewallRule.msg}
                </span>
              ),
              gridSize: 12,
            }
          ],
        },
      ]}
    />
    <AddEditInterfaceModal
      open={isPortForwardModalOpen}
      onClose={handleClosePopup}
      onSave={handleAddPortForward}
      saveText={isEditPopup ? 'Update' : 'Add'}
      disableSave={!isFormValid()}
      title={isEditPopup ? 'Edit Port Forward' : 'Add Port Forward'}
      layout={[
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="WAN Name"
                  isDropdown
                  dropdownOptions={wans?.filter(w => w?.device !== "wwan0")?.map(w => w?.alias)}
                  value={formData?.wan_name}
                  onChange={handleChange("wan_name")}
                  placeholder="Select WAN"
                  disabled={isEditPopup}
                />
              ),
              gridSize: 6,
            },
            {
              component: (
                <LabelValueDisplay
                  label="Protocol"
                  isDropdown
                  dropdownOptions={['TCP','UDP']}
                  value={formData?.protocol}
                  onChange={handleChange("protocol")}
                  placeholder="Select Protocol"
                />
              ),
              gridSize: 6,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <NetworkCardContainer title="Source" borderGradient="linear-gradient(90deg, #597DFF 0%, rgba(53, 75, 153, 0) 100%)">
                  <LabelValueDisplay
                    label="Address"
                    isInput
                    value={formData?.src_ip}
                    onChange={handleChange("src_ip")}
                    placeholder="Enter Address"
                    error={sourceAddressError}
                  />

                  <LabelValueDisplay
                    label="WAN Port"
                    isInput
                    value={formData?.src_port}
                    onChange={handleChange("src_port")}
                    placeholder="Enter IP:Port"
                    error={sourcePortError}
                  />
                </NetworkCardContainer>
              ),
              gridSize: 6,
            },
            {
              component: (
                <NetworkCardContainer title="Destination" borderGradient="linear-gradient(90deg, #6E7079 0%, rgba(53, 75, 153, 0) 100%)">
                  <LabelValueDisplay
                    label="Address"
                    isInput
                    value={formData?.dest_ip}
                    onChange={handleChange("dest_ip")}
                    placeholder="Enter Address"
                    error={destinationAddressError}
                  />

                  <LabelValueDisplay
                    label="Natted Port"
                    isInput
                    value={formData?.dest_port}
                    onChange={handleChange("dest_port", true)}
                    placeholder="Enter IP:Port"
                    error={destinationPortError}
                  />
                </NetworkCardContainer>
              ),
              gridSize: 6,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(getAddEditPortConfig) && getAddEditPortConfig.msg}
                </span>
              ),
              gridSize: 12,
            }
          ],
        },
        // {
        //   columns: [
        //     {
        //       component: (
        //         <NetworkCardContainer
        //           title="NAT"
        //           borderGradient="linear-gradient(90deg, #29B75A 0%, rgba(53, 75, 153, 0) 100%)"
        //         >
        //           <Grid container spacing={2}>
        //             <Grid item xs={6}>
        //               <LabelValueDisplay
        //                 label="IP"
        //                 isInput
        //                 value={formData?.ip}
        //                 onChange={handleChange("ip")}
        //                 placeholder="Enter IP"
        //               />
        //             </Grid>

        //             <Grid item xs={6}>
        //               <LabelValueDisplay
        //                 label="Ports"
        //                 isInput
        //                 value={formData?.ports}
        //                 onChange={handleChange("ports")}
        //                 placeholder="Enter IP:Port"
        //               />
        //             </Grid>
        //           </Grid>
        //         </NetworkCardContainer>
        //       ),
        //       gridSize: 12,
        //     },
        //   ],
        // },
        // {
        //   columns: [
        //     {
        //       component: (
        //         <LabelValueDisplay
        //           label="Description"
        //           isInput
        //           value={formData?.description}
        //           onChange={handleChange("description")}
        //           placeholder="Enter Description"
        //         />
        //       ),
        //       gridSize: 12,
        //     }
        //   ],
        // }
      ]}
    />
    <AddEditInterfaceModal
      open={isNatModalOpen}
      onClose={handleClosePopup}
      onSave={handleAddNatOutbound}
      saveText={'Add'}
      title={'Add NAT Outbound'}
      layout={[
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="WAN Alias"
                  isDropdown
                  dropdownOptions={[]}
                  value={formData?.wan_alias}
                  onChange={handleChange("wan_alias")}
                  placeholder="Select WAN Alias"
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Interface"
                  isDropdown
                  dropdownOptions={[]}
                  value={formData?.interface}
                  onChange={handleChange("interface")}
                  placeholder="Select Interface"
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <ToggleControl
                  label="Outbound NAT"
                  checked={formData?.outboundNat}
                  onChange={(checked) =>
                    setFormData({ ...formData, outboundNat: checked })
                  }
                />

              ),
              gridSize: 12,
            }
          ],
        }
      ]}
    />
    

    {row?.wan_name && (
      <DeleteWANProfileModal
        open={isPortConfigDeleteModalOpen}
        onClose={() => { setIsPortConfigDeleteModalOpen(false); dispatch({ type: GET_DELETE_PORT_CONFIG, payload: {} }) }}
        onConfirm={() => {
          securityAutoRefresh.startAction();
          notifyConfigAction?.();
          getDeletePortConfigData(selectedRow['deviceId'], row['id']);
        }}
        profileName={row?.wan_name}
        errorMessage={getDeletePortConfig?.status == false && getDeletePortConfig?.msg ? getDeletePortConfig?.msg : ''}
      />
    )}
    {row?.name && (
      <DeleteWANProfileModal
        open={isRuleDeleteModalOpen}
        onClose={() => { setIsRuleDeleteModalOpen(false); dispatch({ type: GET_DELETE_FIREWALL_RULE, payload: {} }) }}
        onConfirm={() => {
          securityAutoRefresh.startAction();
          notifyConfigAction?.();
          getDeleteFirewallRuleData(selectedRow['deviceId'], row['id'], activeTab === "qos_rules"? "rate_limit": "filter");
        }}
        entityLabel={`Confirm Firewall rule ${row?.name} deletion.`}
        entityName=""
        warningMessage = ""
        profileName={row?.name}
        confirmText="Confirm"
        errorMessage={getDeleteFirewallRule?.status == false && getDeleteFirewallRule?.msg ? getDeleteFirewallRule?.msg : ''}
      />
    )}
    {identityRuleToDelete && (
      <DeleteWANProfileModal
        open={isIdentityRuleDeleteModalOpen}
        onClose={() => { setIsIdentityRuleDeleteModalOpen(false); setIdentityRuleToDelete(null); }}
        onConfirm={handleConfirmDeleteIdentityRule}
        entityLabel={`Confirm Identity rule ${identityRuleToDelete?.name} deletion.`}
        entityName=""
        warningMessage = ""
        profileName={identityRuleToDelete?.name}
        confirmText="Confirm"
        // errorMessage={getDeleteFirewallRule?.status == false && getDeleteFirewallRule?.msg ? getDeleteFirewallRule?.msg : ''}
      />
    )}
  </div>
  );
}

const mapStateToProps = (state) => ({
  geteAllWanInterfacesForAdvSettings: state.authReducer.geteAllWanInterfacesForAdvSettings,
  geteAllWanInterfacesForAdvSettingsLoading: state.authReducer.geteAllWanInterfacesForAdvSettingsLoading,
  getEnableDisableNoNat: state.authReducer.getEnableDisableNoNat,
  getEnableDisableNoNatLoading: state.authReducer.getEnableDisableNoNatLoading,
  getAllPortConfigs: state.authReducer.getAllPortConfigs,
  getAllPortConfigsLoading: state.authReducer.getAllPortConfigsLoading,
  getAddEditPortConfig: state.authReducer.getAddEditPortConfig,
  getAddEditPortConfigLoading: state.authReducer.getAddEditPortConfigLoading,
  getDeletePortConfig: state.authReducer.getDeletePortConfig,
  getDeletePortConfigLoading: state.authReducer.getDeletePortConfigLoading,
  getAllFirewallRules: state.authReducer.getAllFirewallRules,
  getIdentityRules: state.authReducer.getIdentityRules,
  getIdentityRulesLoading: state.authReducer.getIdentityRulesLoading,
  getAllFirewallRulesLoading: state.authReducer.getAllFirewallRulesLoading,
  getInterfacesFirewallRules: state.authReducer.getInterfacesFirewallRules,
  getInterfacesFirewallRulesLoading: state.authReducer.getInterfacesFirewallRulesLoading,
  getAddEditFirewallRule: state.authReducer.getAddEditFirewallRule,
  getAddEditFirewallRuleLoading: state.authReducer.getAddEditFirewallRuleLoading,
  getEnableDisableFirewallRule: state.authReducer.getEnableDisableFirewallRule,
  getEnableDisableFirewallRuleLoading: state.authReducer.getEnableDisableFirewallRuleLoading,
  enableDisablePortConfig: state.authReducer.getEnableDisablePortForward,
  getEnableDisablePortForwardLoading: state.authReducer.getEnableDisablePortForwardLoading,
  getDeleteFirewallRule: state.authReducer.getDeleteFirewallRule,
  getDeleteFirewallRuleLoading: state.authReducer.getDeleteFirewallRuleLoading,
  setFirewallRulePriorityLoading: state.authReducer.setFirewallRulePriorityLoading,
  getIdentityRuleDetails: state.authReducer.getIdentityRuleDetails,
  getAllInterfaces: state.authReducer.getAllInterfaces,
  getIdentityRulesByIdLoading: state.authReducer.getIdentityRulesByIdLoading,
  createUpdateIdentityRule: state.authReducer.createUpdateIdentityRule,
  deletedIdentityRule: state.authReducer.deletedIdentityRule,
  fetchFwProtocols: state.authReducer.fetchFwProtocols,
  deviceLinkStatusLoading: state.authReducer.getDeviceLinkStatusLoading,
});

export default withRouter(
  connect(mapStateToProps, { geteAllWanInterfacesForAdvSettingsData, getEnableDisableNoNatData, getAllPortConfigsData, getAddEditPortConfigData, getDeletePortConfigData, getAllFirewallRulesData, getIdentityRuleList, getInterfacesFirewallRulesData, getAddEditFirewallRuleData, getEnableDisableFirewallRuleData, getDeleteFirewallRuleData, getEnableDisablePortForwardData,updateFirewallPriorityAPI, getIdentityRuleById, getAllInterfacesData, addEditIdentityRule, deleteIdentityRule, geFirewallProtocolList, getDeviceLinkStatusData })(SecurityTab)
)